module.exports = __webpack_public_path__ + "img/lg_ring_y_l_null_1.2b5dffd6.png";